export function fromReactNativeApp(): boolean {
    return !!window.ReactNativeWebView;
}

export function postReactNativeAppData(type: any, data: any, dismiss: boolean = false) {
    if (fromReactNativeApp()) {
        window.ReactNativeWebView.postMessage(
            JSON.stringify({
                type,
                data,
                dismiss,
            })
        );
    }
}
